import { SelectionRequest } from '@tiendanube/common';

export interface FormState {
  currentStep: number;
  answers: Record<string, SelectionRequest[]>;
  stepHistory: number[];
}

export type AnswerAction =
  | {
      type: 'ANSWER_GROUP';
      payload: {
        groupKey: string;
        values: SelectionRequest[];
      };
    }
  | {
      type: 'PREV_STEP';
    }
  | {
      type: 'SET_STEP_WITH_HISTORY';
      payload: {
        stepIndex: number;
      };
    };

const formReducer = (state: FormState, action: AnswerAction): FormState => {
  switch (action.type) {
    case 'ANSWER_GROUP':
      return {
        ...state,
        answers: {
          ...state.answers,
          [action.payload.groupKey]: action.payload.values,
        },
      };
    case 'PREV_STEP': {
      const newHistory = [...state.stepHistory];
      newHistory.pop(); // Eliminamos el paso actual
      const prevIndex = newHistory.at(-1) ?? 0;
      return {
        ...state,
        currentStep: prevIndex,
        stepHistory: newHistory,
      };
    }
    case 'SET_STEP_WITH_HISTORY':
      return {
        ...state,
        currentStep: action.payload.stepIndex,
        stepHistory: [...state.stepHistory, action.payload.stepIndex],
      };
    default:
      return state;
  }
};

export default formReducer;
